module.exports = {
	"id": "RE",
	"name": "Reunion",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006755,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01351,
			"19": null,
			"20": null,
			"21": 0.006755,
			"22": 0.020265,
			"23": 0.01351,
			"24": null,
			"25": null,
			"26": 0.006755,
			"27": null,
			"28": 0.02702,
			"29": 0.020265,
			"30": 0.06755,
			"31": 0.02702,
			"32": 0.033775,
			"33": 0.02702,
			"34": 0.04053,
			"35": 0.033775,
			"36": 0.060795,
			"37": 0.02702,
			"38": 0.04053,
			"39": 0.06755,
			"40": 0.033775,
			"41": 0.020265,
			"42": 0.020265,
			"43": 0.074305,
			"44": 0.41881,
			"45": 0.05404,
			"46": 0.08106,
			"47": 0.101325,
			"48": 0.10808,
			"49": 1.438815,
			"50": 0.168875,
			"51": 0.44583,
			"52": 0.52689,
			"53": 22.84541,
			"54": 5.599895,
			"55": 0.060795,
			"56": 0.01351,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.01351,
			"5": null,
			"6": 0.01351,
			"7": 0.01351,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.033775,
			"12": 0.020265,
			"13": null,
			"14": 0.020265,
			"15": 0.047285,
			"16": 0.047285,
			"17": 0.01351,
			"18": null,
			"19": 0.01351,
			"20": 0.04053,
			"21": 0.006755,
			"22": 0.006755,
			"23": 0.141855,
			"24": 0.14861,
			"25": 0.033775,
			"26": 0.020265,
			"27": null,
			"28": 0.02702,
			"29": 0.006755,
			"30": 0.047285,
			"31": 0.101325,
			"32": 0.344505,
			"33": 0.04053,
			"34": 0.06755,
			"35": 0.05404,
			"36": 0.05404,
			"37": 0.074305,
			"38": 0.952455,
			"39": 0.05404,
			"40": 0.263445,
			"41": 0.62146,
			"42": 0.182385,
			"43": 0.21616,
			"44": 0.290465,
			"45": 0.45934,
			"46": 0.18914,
			"47": 0.655235,
			"48": 0.857885,
			"49": 10.68641,
			"50": 0.06755,
			"51": null,
			"52": null,
			"3.5": 0.006755,
			"3.6": 0.047285
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.10808,
			"37": 0.033775,
			"38": 0.04053,
			"39": 0.006755,
			"40": 0.58093,
			"41": 0.060795,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01351
		},
		"safari": {
			"0": null,
			"4": 0.02702,
			"5": 0.047285,
			"6": 0.020265,
			"7": 0.02702,
			"8": 0.17563,
			"9": 0.28371,
			"10": 1.952195,
			"3.1": 0.006755,
			"3.2": null,
			"5.1": 0.22967,
			"6.1": 0.128345,
			"7.1": 0.060795,
			"9.1": 1.4861
		},
		"ios_saf": {
			"8": 0,
			"10": 3.86098321399,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.104049029975,
			"8.1-8.4": 0.192226174022,
			"9.0-9.2": 0.0917042298085,
			"9.3": 1.39907735221
		},
		"android": {
			"3": 0,
			"4": 0.0435651782946,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00544564728682,
			"4.1": 0.157145821705,
			"4.2-4.3": 0.392864554264,
			"4.4": 0.900865651163,
			"4.4.3-4.4.4": 0.908645147287
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.244018551724,
			"9": 0.142344155172,
			"10": 0.142344155172,
			"11": 3.40270313793,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0315632372465,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00087675659018
		},
		"edge": {
			"12": 0.276955,
			"13": 0.736295,
			"14": 1.817095
		},
		"ie_mob": {
			"10": 0.105609295775,
			"11": 0.429980704225
		},
		"bb": {
			"7": 0.0040575,
			"10": null
		},
		"samsung": {
			"0": 4.30095
		},
		"and_uc": {
			"0": 0.136332
		},
		"op_mini": {
			"0": 0.425246006163
		},
		"and_chr": {
			"0": 23.254474
		},
		"and_ff": {
			"0": 0.042198
		}
	},
	"total": 98.3934595
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/RE.json
 ** module id = 632
 ** module chunks = 0
 **/